// extracted by mini-css-extract-plugin
module.exports = {"root":"figure-module--root--3JVkH"};